import axios from '../request/http';

const home = {
    // 乡村排行
    villageRanking(params) {
        return axios.get("/hemei-admin/dashboard/villageRanking",{params});
    },
    // 商品分类排行
    goodsList(params){
        return axios.get("/hemei-admin/dashboard/category/goodsList",{params});
    },
    // 用户数量
    userNumber(params){
        return axios.get("/hemei-admin/dashboard/userNumber",{params});
    },
    // 订单详情接口
    order(params){
        return axios.get("/hemei-admin/dashboard/order",{params});
    },
    // 查询话题排行
    getRank(params){
        return axios.get("/service-article/topic/getRank",{params});
    },
    // 订单数范围查询
    orderCount(params){
        return axios.get("/hemei-admin/dashboard/orderCount",{params});
    },
    // 文章数查询
    counts(params){
        return axios.get("/service-article/analyze/counts",{params});
    },
    // 查询话题列表
    getList(params){
        return axios.get("/service-article/topic/getList",{params});
    },
    // 新增或修改话题
    saveOrUpdateTopic(data){
        return axios.post("/service-article/topic/saveOrUpdateTopic", data );
    },
    // 删除 话题
    deletePo(params){
        return axios.get("/service-article/topic/delete",{params});
    },
    // 管理员对文章进行推荐
    recommend(params){
        return axios.get("/service-article/article/recommend",{params});
    },
    // 获得短信验证码
    getSMSCode(params){
        return axios.get("/hemei-admin/login/getSMSCode",{params});
    },
     // 查询话题分组
     getGroupt(params){
        return axios.get("/service-article/topic/getGroup", { params } );
    },
    // 分裂列表
    getListyu(params){
        return axios.get("/hemei-admin/category/topic/list", { params } );
    }

    
  
    
}

export default home;


// WEBPACK FOOTER //
// ./src/api/home.js